import { cookie } from './cookie';

export const AUTH_COOKIE_NAME = '83D6F85345D8459aB80D97E8B1BB90CE';

export function getAuthToken(): string | undefined {
  return cookie.get(AUTH_COOKIE_NAME);
}
